import React, { Component } from 'react';
import { Field } from 'redux-form';
import InputField from 'components/InputField';

class LineItemRow extends Component {
  render() {
    let { member, index, fields } = this.props;

    let values = fields.get(index) || {};
    let qty = Number(values.quantity) || 0;
    let unitPrice = Number(values.unit_price) || 0;
    let taxRate = Number(values.tax_rate) || 0;
    let discountValue = Number(values.discount_value) || 0;
    let discountType = values.discount_type || 'fixed';

    let lineTotal = qty * unitPrice;
    if (discountType === 'percentage') {
      lineTotal -= lineTotal * (discountValue / 100);
    } else {
      lineTotal -= discountValue;
    }
    lineTotal += lineTotal * (taxRate / 100);

    return (
      <tr>
        <td>
          <Field
            className="form-control input-sm"
            name={`${member}.title`}
            component={InputField}
            type="text"
            label="Item name"
          />
        </td>
        <td>
          <Field
            className="form-control input-sm"
            name={`${member}.quantity`}
            component={InputField}
            type="number"
            label="1"
            min="0"
            step="1"
          />
        </td>
        <td>
          <Field
            className="form-control input-sm"
            name={`${member}.unit_price`}
            component={InputField}
            type="number"
            label="0.00"
            min="0"
            step="0.01"
          />
        </td>
        <td>
          <Field
            className="form-control input-sm"
            name={`${member}.tax_rate`}
            component={InputField}
            type="number"
            label="0"
            min="0"
            step="0.01"
          />
        </td>
        <td>
          <Field
            className="form-control input-sm"
            name={`${member}.discount_value`}
            component={InputField}
            type="number"
            label="0"
            min="0"
            step="0.01"
          />
        </td>
        <td>
          <Field className="form-control input-sm" name={`${member}.discount_type`} component="select">
            <option value="fixed">Fixed</option>
            <option value="percentage">%</option>
          </Field>
        </td>
        <td style={{ textAlign: 'right', verticalAlign: 'middle' }}>
          <span>{lineTotal.toFixed(2)}</span>
        </td>
        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
          <i
            className="fa fa-times-circle location-panel-remove"
            style={{ cursor: 'pointer', color: '#d9534f' }}
            onClick={() => fields.remove(index)}
          ></i>
        </td>
      </tr>
    );
  }
}

class LineItemsEditor extends Component {
  render() {
    let { fields } = this.props;

    return (
      <div>
        <table className="table table-condensed table-bordered" style={{ tableLayout: 'fixed' }}>
          <colgroup>
            <col style={{ width: '30%' }} />
            <col style={{ width: '8%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '9%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '12%' }} />
            <col style={{ width: '6%' }} />
          </colgroup>
          <thead>
            <tr>
              <th>Title</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Tax %</th>
              <th>Discount</th>
              <th>Type</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fields.map((member, index) => (
              <LineItemRow
                key={index}
                member={member}
                index={index}
                fields={fields}
              />
            ))}
          </tbody>
        </table>
        <button
          type="button"
          className="btn btn-default btn-sm"
          onClick={() => fields.push({
            title: '',
            quantity: 1,
            unit_price: 0,
            tax_rate: 0,
            discount_value: 0,
            discount_type: 'fixed'
          })}
        >
          <i className="fa fa-plus"></i>&nbsp;Add Line Item
        </button>
      </div>
    );
  }
}

export default LineItemsEditor;



// WEBPACK FOOTER //
// app/components/drafts/LineItemsEditor.jsx